<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <label class="d-inline-flex align-items-center">
              <b-form-checkbox v-model="typeDataShow" name="check-button" switch>
                Data: <b>({{ typeDataShow ? "Terdaftar" : "Belum Terdaftar" }})</b>
              </b-form-checkbox>
            </label>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="accountData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'btn'">
                      <b-button :disabled="props.row.is_received" class="w-sm" v-b-modal.modal-donasi @click="setModalDonasi(props.row)">
                        Pilih Donatur
                      </b-button>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <b-modal id="modal-donasi" title="Donasi" button-size="sm">
              <label for="donatur">Pilih Donatur:</label>
              <multiselect id="donatur" v-model="selectedDonatur"
                           :options="donaturData"
                           track-by="transaction_id"
                           label="account_email"
                           name="account_email"
                           placeholder="Cari Donatur"
                           :internal-search="false"
                           @search-change="getDonaturData">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.account_email }}</strong> ({{ option.slot_available }})</template>
              </multiselect>
              <div v-if="Object.keys(selectedDonatur).length !== 0">
                <p>
                  Email: {{ selectedDonatur.account_email }}<br>
                  Paket: {{ selectedDonatur.product_name }} - {{ selectedDonatur.month }} Bulan<br>
                </p>
              </div>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button variant="primary" size="sm" @click="donateToUser(selectedDonatur, activeAccount)">
                  <div v-if="loading">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Submit
                  </div>
                </b-button>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import axios from 'axios';
import Swal from "sweetalert2";
export default {
  name: "ping-guru",
  page: {
    title: "Penerima Donasi",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Multiselect },
  created() {
    this.fetchAccountData()
  },
  data() {
    return {
      title: "Penerima Donasi",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      loading: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      accountData: [],
      donaturData: [],
      columns: [
        { field: "timestamp", label: "Timestamp" },
        { field: "email", label: "Email" },
        { field: "nama_depan", label: "Nama Depan" },
        { field: "Nama Belakang", label: "Nama Depan" },
        { field: "mata_pelajaran", label: "Mata Pelajaran" },
        { field: "tahun_mengajar", label: "Tahun Mengajar" },
        { field: "alasan_penerima", label: "Alasan Penerima" },
        { field: "sumber_informasi", label: "Sumber Informasi" },
        { field: "tempat_bekerja", label: "Tempat Bekerja" },
        { field: "is_received", label: "Sudah Menerima Donasi" },
        { field: "btn", label: "Action" },
      ],
      exportLoading: false,
      typeDataShow: false,
      selectedDonatur: {},
      activeAccount: {}
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchAccountData() {
      let params = queryString.stringify({
        ...{
          email: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallAccountData(params)
    },
    httpCallAccountData(params) {
      axios.get("/api/penerima-donasi?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.accountData = data
            this.isFetched = true
          });
    },
    httpCallDonaturData(params) {
      axios.get("/api/transaction/donation?"+params)
          .then(resp => {
            const { data } = resp.data
            this.donaturData = data
          });
    },
    exportUser() {
      this.exportLoading = true
      axios.get("/api/penerima-donasi/export")
          .then(resp => {
            const { data } = resp.data
            var temp = 'data:application/vnd.ms-excel;base64,'
                +encodeURIComponent(data);
            var download = document.createElement('a');
            download.href = temp;
            download.download = 'ping-guru-export.xlsx';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            this.exportLoading = false
          });
    },
    getDonaturData(query) {
      let params = queryString.stringify({
        page: 1,
        limit: 100,
        email: query,
        available_slot: true
      })
      this.httpCallDonaturData(params)
    },
    setModalDonasi(rowData) {
      this.selectedDonatur = {}
      this.activeAccount = rowData
      let params = queryString.stringify({
        page: 1,
        limit: 100,
        email: '',
        available_slot: true
      })
      this.httpCallDonaturData(params)
    },
    donateToUser(selectedDonatur, activeAccount) {
      this.loading = true
      if (Object.keys(selectedDonatur).length === 0) {
        Swal.fire('Pilih user terlebih dahulu')
        return
      }
      const request = {
        email: activeAccount.email,
        transaction_id: selectedDonatur.transaction_id,
      }
      axios.put("/api/penerima-donasi/"+activeAccount.id, request)
          .then(resp => {
            Swal.fire('Sukses')
            this.$bvModal.hide('modal-donasi')
            this.fetchAccountData()
          }).catch(resp => {
            Swal.fire('Internal Server Error')
          });
    }
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        email: value,
        sort: '-id',
        pengguna: this.typeDataShow
      })
      this.httpCallAccountData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          email: this.searchText,
          sort: '-id',
          pengguna: this.typeDataShow
        })
        this.httpCallAccountData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          email: this.searchText,
          sort: '-id',
          pengguna: this.typeDataShow
        })
        this.httpCallAccountData(params)
      }
    },
    typeDataShow(value) {
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        email: '',
        sort: '-id',
        pengguna: value
      })
      this.httpCallAccountData(params)
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>